module.exports = __webpack_public_path__ + "static/media/link.6d85254a.svg";